/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {DungeonQuestServerDataParser} from "../DungeonQuestServerDataParser";

export interface ColossalSymbolInfo {
    entireSymbolVisible:boolean;
    position:[number, number];
    size:number;
    symbol:string;
    transformTriggered:boolean;
}

export class DungeonQuestParsedGameData extends SpinParsedGameData {

    get freespinsPlayed():number {
        return this._freespinsPlayed;
    }

    get overlaySymbolsAfterSpin():string[][] {
        return this._overlaySymbolsAfterSpin;
    }

    get overlaySymbolsBeforeSpin():string[][] {
        return this._overlaySymbolsBeforeSpin;
    }

    get symbolToBeTransformed():string {
        return this._symbolToBeTransformed;
    }

    get overlayReels():string[][] {
        return this._overlayReels;
    }

    get symbolTransformTriggered():boolean {
        return this._symbolTransformTriggered;
    }

    get freespinsRemaining():number {
        return this._freespinsRemaining;
    }

    get bigSymbolInfoList():ColossalSymbolInfo[] {
        return this._bigSymbolInfoList;
    }

    public get freespinTriggeredThisSpin():boolean {
        return this._freespinTriggered;
    }

    private readonly _freespinTriggered:boolean;

    private readonly _bigSymbolInfoList:ColossalSymbolInfo[];
    private readonly _freespinsRemaining:number;
    private readonly _freespinsPlayed:number;
    private readonly _symbolTransformTriggered:boolean;

    private readonly _overlayReels:string[][];
    private readonly _overlaySymbolsBeforeSpin:string[][];
    private readonly _overlaySymbolsAfterSpin:string[][];
    private readonly _symbolToBeTransformed:string;

    constructor(rawData:any, dataParser:DungeonQuestServerDataParser) {
        super(rawData, dataParser);

        this._bigSymbolInfoList = rawData.bigSymbolInfoList;
        this._symbolTransformTriggered = rawData.symbolTransformTriggered;
        this._freespinsRemaining = rawData.freespinsRemaining;
        this._freespinsPlayed = rawData.freespinsPlayed;

        this._overlayReels = rawData.overlayReels;
        this._overlaySymbolsBeforeSpin = rawData.overlaySymbolsBeforeSpin;
        this._overlaySymbolsAfterSpin = rawData.overlaySymbolsAfterSpin;
        this._symbolToBeTransformed = rawData.symbolToBeTransformed;

        this._freespinTriggered = rawData.freespinTriggered;
    }


}